// Reference here all possible title sizes, they are sorted from bigger to lowest size
export enum TitleSize {
  Jumbo2 = 'Jumbo2',
  Jumbo1 = 'Jumbo1',
  H2XL = 'H2XL',
  HXL = 'HXL',
  HL = 'HL',
}
